import { createBrowserHistory } from 'history';
import React from 'react';
import { render } from 'react-dom';
import { Router } from 'react-router';
import { bootstrap } from '~admin/bootstrap';
import { Root } from '~admin/view/root';

bootstrap();
const browserHistory = createBrowserHistory();

const renderApp = (App: React.FunctionComponent): void =>
  render(
    <Router history={browserHistory}>
      <App />
    </Router>,
    document.querySelector('#root'),
  );

renderApp(Root);

const webModule = module as any;
const hotModuleReloader = webModule.hot;
const moduleId = require.resolve('./view/root');
if (hotModuleReloader) {
  hotModuleReloader.accept(moduleId, (): void => {
    renderApp(Root);
  });
}



// WEBPACK FOOTER //
// ./app.tsx